import { createRoute } from '@tanstack/react-router'
import { Route as rootRoute } from '@/app/__root'
import { ROUTES } from '@/shared/constants/routes'
import { DesignSystemPage } from './page.design-system'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: ROUTES.DESIGN_SYSTEM,
  component: DesignSystemPage,
})
